module.exports = __webpack_public_path__ + "static/covid-99c91571d2ebae589d603c64c7f5135e.png";